<div class="row p-2 mb-3 align-items-center">
  <div class="col-12 col-md-7 text-start">
    <div class="page-title-heading">
      <div class="page-title-icon"><i class="fa-solid fa-square-poll-vertical"></i></div>
      <div>
        Sondage
        <div class="page-title-subheading">Sondages adressés aux familles</div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-5 text-end">
    <app-header></app-header>
  </div>
</div>
   <div class="row">
    <div class="col-lg-12">
        <div class="card">
          
            <div class="card-body">
                  <div class="d-flex justify-content-between mb-5">
                    <div class="me-2">
                        <button *ngIf="buttonsPermission?.add" type="button" class="btn btn-danger btn-sm" (click)="add(addContent)">
                            <i class="fa-solid fa-plus me-2" aria-hidden="true"></i>Nouveau sondage
                            </button>
                    </div>
                    <div class=" " *ngIf="buttonsPermission">
                        <button *ngIf="selected_data && buttonsPermission.show"  (click)="show(showContent)" type="button" class="btn btn-outline-primary btn-sm btn-label waves-effect waves-light me-3">
                             <span>Consulter</span></button>
                        <button *ngIf="selected_data && buttonsPermission.edit" (click)="edit(editContent)" type="button"  class="btn btn-outline-warning btn-sm btn-label waves-effect waves-light me-3">
                           Editer</button>
                        <button *ngIf="selected_data && buttonsPermission.delete" (click)="delete()" type="button" class="btn btn-outline-danger btn-sm btn-label waves-effect waves-light me-3">
                             Supprimer</button>
                             <button *ngIf="selected_data && is_active!=null && !is_active" (click)="setStatus(1)" type="button" class="btn btn-outline-success btn-sm btn-label waves-effect waves-light me-3">
                                Lancer</button>
                               <button  *ngIf="selected_data && is_active!=null && is_active" (click)="setStatus(0)" type="button" class="btn btn-outline-danger btn-sm btn-label waves-effect waves-light me-3">
                                Arrêter le sondage</button>
                    </div>

                    <div class="form-group ms-auto">
                        <label for=""> <strong>Rechercher:</strong> </label>
                        <input placeholder="Rechercher..." class="form-control form-control-sm" type="text" name="search_text" [(ngModel)]="search_text">
                    </div>
                </div>

                        <p>{{data!.length}} élément(s)</p>
                        <div class="table-responsive">
                        <table class="table table-striped table-hover table-borderless table-sm" >
                            <thead class="">
                                <tr>
                                    <th style="width: 10px;">#</th>
                                    <th>Titre</th>
                                    <th>Détails</th>
                                    <th>Cible</th>
                                    <th>Statut</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr (click)="checked(d)" [class.table-active]="selected_data?.id === d.id" style="cursor: pointer;" *ngFor="let d of data | sampleSearch:search_text:'periods' | paginate: {
                                id:'ngxP1',
                                itemsPerPage: pg.pageSize,
                                currentPage: pg.p,
                                totalItems: pg.total } ">
                                    <td>
                                        <div class="form-check mb-2">
                                            <input (click)="checked(d)" class="form-check-input" type="radio" [checked]="selected_data?.id === d.id" name="flexRadioDefault">
                                        
                                        </div>
                                    </td>
                                    <td>{{d.name}}</td>
                                    <td>{{d.details}}</td>
                                    <td>{{d.types}}</td>
                                    <td>
                                        <span *ngIf="d.is_active" class="badge bg-success">Lancé</span>
                                        <span *ngIf="!d.is_active" class="badge bg-danger">Non lancé</span>

                                    </td>
                                </tr>
                            
                            </tbody>
                        </table>
                        </div>
                          <pagination-controls 
                        id="ngxP1"
                        (pageChange)="getPage($event)"
                      [maxSize]="9"
                      [directionLinks]="true"
                      [autoHide]="true"
                      [responsive]="true"
                      [previousLabel]="'Précédent'"
                      [nextLabel]="'Suivant'"
                      [screenReaderPaginationLabel]="'Pagination'"
                      [screenReaderPageLabel]="'page'"
                      [screenReaderCurrentLabel]="'Vous êtes sur la page'">
                     </pagination-controls>

            </div><!-- end card -->
        </div>
        <!-- end col -->
    </div>
    <!-- end col -->
</div>


<ng-template #addContent let-c="close" let-d="dismiss">
    <form #addForm="ngForm" (ngSubmit)="store(addForm.value)">
    <div class="modal-header">
      <h6 class="modal-title" id="modal-basic-title">Enregistrer un sondage</h6>
      <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
    </div>
    <div class="modal-body" >
        <div class="row mb-3" >

            <div class=" form-group col-12 mb-3">
                <label for="">Cibles<span class="text-danger ml-2">(*)</span></label>
                <ng-select name="types" ngModel [multiple]="true">
                    <ng-option *ngFor="let c of cibles"  [value]="c">{{c}}</ng-option>
                </ng-select>
            </div>
           
            <div class=" form-group col-12 mb-3">
                <label for="">Titre <span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="name" class="form-control" ngModel>
            </div>
           
            <div class=" form-group col-12 mb-3">
                <label for="">Contenu <span class="text-danger ml-2">(*)</span></label>
                <textarea name="details" ngModel class="form-control"></textarea>
            </div>
        </div>

        <h6>Eléments de sondage</h6>
            <div *ngFor="let l of lines; let i=index" class="input-group mb-3">
                <input type="text" name="name" [(ngModel)]="lines[i].name" class="form-control"  aria-describedby="button-addon2" required>
                <button class="btn btn-outline-secondary" type="button" id="button-addon2" style="cursor: pointer;" ><i (click)="removeLine(i)" class="fa fa-times text-danger"></i></button>
              </div>
              <div class="text-center">
                <button type="button" class="btn btn-sm btn-primary" style="cursor: pointer;" (click)="addLine()">Insérer un élement</button>

              </div>
        
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-outline-dark" [disabled]="addForm.invalid"  >Enregistrer <app-loading [isVisible]="loading"></app-loading></button>
    </div>
</form>
  </ng-template>

  <ng-template #editContent let-c="close" let-d="dismiss">
    <form #editForm="ngForm" (ngSubmit)="update(editForm.value)">
    <div class="modal-header">
      <h6 class="modal-title" id="modal-basic-title">Modifier un sondage</h6>
      <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
    </div>
    <div class="modal-body" >
        <div class="row mb-3" >

            <div class=" form-group col-12 mb-3">
                <label for="">Cibles<span class="text-danger ml-2">(*)</span></label>
                <ng-select name="types" [(ngModel)]="selected_data.types" [multiple]="true">
                    <ng-option *ngFor="let c of cibles"  [value]="c">{{c}}</ng-option>
                </ng-select>
            </div>
           
            <div class=" form-group col-12 mb-3">
                <label for="">Titre <span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="name" class="form-control" [(ngModel)]="selected_data.name">
            </div>
           
            <div class=" form-group col-12 mb-3">
                <label for="">Contenu <span class="text-danger ml-2">(*)</span></label>
                <textarea name="details" [(ngModel)]="selected_data.details" class="form-control"></textarea>
            </div>
        </div>

        <h6>Eléments de sondage</h6>
            <div *ngFor="let l of lines; let i=index" class="input-group mb-3">
                <input type="text" name="name" [(ngModel)]="l.name" class="form-control"  aria-describedby="button-addon2" required>
                <button class="btn btn-outline-secondary" type="button" id="button-addon2" style="cursor: pointer;" ><i (click)="removeLine(i)" class="fa fa-times text-danger"></i></button>
              </div>
        <p class="text-center text-primary" style="cursor: pointer;" (click)="addLine()">Insérer un élement</p>
        
       
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-outline-dark" [disabled]="editForm.invalid" >Sauvegarder <app-loading [isVisible]="loading"></app-loading></button>
    </div>
</form>
  </ng-template>

  <ng-template #showContent let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Détails des informations</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
      </div>

      <div class="modal-body">
        <div class="row">
            <div class="col-12 col-md-8">
                <dl class="mb-3">
                    <dt>Titre</dt>
                    <dd>{{selected_data.name}}</dd>
                   </dl>
                   <dl class="mb-3">
                    <dt>Details</dt>
                    <dd>{{selected_data.details}}</dd>
                   </dl>
                   <dl class="mb-3">
                    <dt>Cible</dt>
                    <dd>
                        <ul>
                            <li *ngFor="let c of selected_data.types">{{c}}</li>
                        </ul>
                    </dd>
                   </dl>
                   <dl class="mb-3">
                    <dt>Eléments du sondage</dt>
                    <dd>
                        <ul>
                            <li *ngFor="let l of selected_data.lines">{{l.name}}</li>
                        </ul>
                    </dd>
                   </dl>
            </div>
            <div class="col-12 col-md-4" style="overflow-y: scroll;">
                <h6><strong>Destinataire</strong></h6>
                <div class="bg-gray mb-1 rounded-0" *ngFor="let d of selected_data.destinators">
                   <p>{{d.name}}</p>
                </div>
            </div>
       

        </div>

      </div>
</ng-template>
